module.exports = __webpack_public_path__ + "static/media/beida.4fe13804.png";